export default __webpack_public_path__ + "static/media/chevron-down.1dee024e.svg";